// extracted by mini-css-extract-plugin
export default {"list":"PdfEditMenuButton__list--3_-j5","itemWrapper":"PdfEditMenuButton__itemWrapper--XXQPA","item":"PdfEditMenuButton__item--mpHRy","scale":"PdfEditMenuButton__scale--1MQP_"};